import React from 'react'
import useProfileSession from '../../hooks/useProfileSession'
import { verifyFeatureAccess } from './utils'
import UnauthorizedPage from '../../pages/unauthorized'
import { Box, CircularProgress } from '@mui/material'
import { useProducts } from '../../hooks'

const Loading = () => {
  return (
    <Box
      display='flex'
      minHeight='70vh'
      justifyContent='center'
      alignItems='center'
      p={10}
    >
      <CircularProgress size={75} />
    </Box>
  )
}

const AuthorizeFeature = ({ feature, component }) => {
  const { profile, isProfileCached } = useProfileSession()
  const { hasContentHubAccess } = useProducts()

  if (feature === 'contentHub' && !hasContentHubAccess) {
    return <UnauthorizedPage />
  }

  // When there's no profile in the cache or redux state show a loading spinner.
  if (!profile) {
    return <Loading />
  }

  const denyAccess = feature && !verifyFeatureAccess(profile?.features, feature, profile?.userGroup, hasContentHubAccess)

  // When a user does not have access to the feature via the cache show a loading spinner.
  if (denyAccess && isProfileCached) {
    return <Loading />
  }

  // When a user does not have access to the feature via the state show an access denied component else show the component.
  return denyAccess && !isProfileCached ? <UnauthorizedPage /> : component
}

export default AuthorizeFeature
